import './LatestJobs.css'
import { Link } from 'react-router-dom'; 
let LatestJobs=(props)=>{
   
let jobclickhandel=(e)=>{
    props.getclickedonvacancyfunction(e);
}
    return(
        <div className='meincomplatestjob'>
            
            <div className='latjobcont'>
                <h2 className='latheading'>Latest Jobs</h2>
                {
                   props.singledata!=="" ?  props.singledata.map(
                        dd=>(
                             <Link className='jobslink' onClick={()=>{jobclickhandel(dd)}}  style={{display:"block"}}><li>{dd.jobtitle}</li>
                             </Link>  
                        )
                    ) : window.location="/search-jobs.com"
                }
                 
            </div> 

        </div>
    );
}
export default LatestJobs;